// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bPp6","header":"ReportDetails_header__1ec8k","title":"ReportDetails_title__zXc4d","left":"ReportDetails_left__3jrDd"};